export const brandsConfigs = {
	linker: {
		brand: 'Linker',
		name: {
			en: 'Linker',
			ar: 'لنكر',
		},
		colors: {
			transparent: 'transparent',
			current: 'currentColor',
			gray: {
				25: '#FCFCFD',
				50: '#F9FAFB',
				100: '#F2F4F7',
				200: '#EAECF0',
				300: '#D0D5DD',
				400: '#98A2B3',
				500: '#667085',
				DEFAULT: '#667085',
				600: '#475467',
				700: '#344054',
				800: '#182230',
				900: '#101828',
				950: '#0C111D',
			},
			brand: {
				25: '#FFFAF8',
				50: '#FEF4EE',
				100: '#FCE5D8',
				200: '#F9C8AF',
				300: '#F5A17C',
				400: '#EF7048',
				500: '#EC552F',
				DEFAULT: '#EC552F',
				600: '#DC341A',
				700: '#B72517',
				950: '#3F0B0B',
			},
			error: {
				25: '#FFFBFA',
				50: '#FEF3F2',
				100: '#FEE4E2',
				200: '#FECDCA',
				300: '#FDA29B',
				400: '#F97066',
				500: '#F04438',
				DEFAULT: '#F04438',
				600: '#D92D20',
				700: '#B42318',
				800: '#912018',
				900: '#7A271A',
				950: '#55160C',
			},
			warning: {
				25: '#FFFCF5',
				50: '#FFFAEB',
				100: '#FFFAEB',
				200: '#FEDF89',
				300: '#FEC84B',
				400: '#FDB022',
				500: '#FDB022',
				DEFAULT: '#FDB022',
				600: '#DC6803',
				700: '#B54708',
				800: '#93370D',
				900: '#7A2E0E',
				950: '#4E1D09',
			},
			success: {
				25: '#F6FEF9',
				50: '#ECFDF3',
				100: '#DCFAE6',
				200: '#ABEFC6',
				300: '#75E0A7',
				400: '#47CD89',
				500: '#17B26A',
				DEFAULT: '#17B26A',
				600: '#079455',
				700: '#067647',
				800: '#085D3A',
				900: '#074D31',
				950: '#074D31',
			},
			secondary: {
				50: '#F6F9F8',
				100: '#D5E6E0',
				200: '#B4D2C8',
				300: '#93BFB0',
				400: '#72AB98',
				500: '#519881',
				DEFAULT: '#519881',
				600: '#407967',
				700: '#305B4D',
				800: '#203C33',
				900: '#101E19',
			},
		},
		logo: 'linker_logo.jpg',
		grayLogo: 'assets/image/gray-logo.svg',
		whatsAppSupportNumber: '966558209024',
		imagePlaceholder: 'assets/image/linker_placeholder.png',
		whatsAppMessageColor: '#FDE4CF',
		currency: 'sar',
	},
	reachMore: {
		brand: 'ReachMore',
		name: {
			en: 'Reach More',
			ar: 'ريتش مور',
		},
		colors: {
			transparent: 'transparent',
			current: 'currentColor',
			gray: {
				25: '#FCFCFD',
				50: '#F9FAFB',
				100: '#F2F4F7',
				200: '#EAECF0',
				300: '#D0D5DD',
				400: '#98A2B3',
				500: '#667085',
				DEFAULT: '#667085',
				600: '#475467',
				700: '#344054',
				800: '#182230',
				900: '#101828',
				950: '#0C111D',
			},
			brand: {
				50: '#e6effd',
				100: '#b0ccf9',
				200: '#8ab4f7',
				300: '#5591f3',
				400: '#347cf1',
				500: '#015bed',
				DEFAULT: '#015bed',
				600: '#0153d8',
				700: '#0141a8',
				800: '#013282',
				900: '#002664',
			},
			error: {
				25: '#fdecea', // missing
				50: '#fdecea',
				100: '#f8c3bd',
				200: '#f5a79d',
				300: '#f17e70',
				400: '#ee6554',
				500: '#ea3f29',
				DEFAULT: '#ea3f29',
				600: '#d53925',
				700: '#a62d1d',
				800: '#812317',
				900: '#621a11',
				950: '#621a11', // missing
			},
			warning: {
				25: '#fffae9', // missing
				50: '#fffae9',
				100: '#ffefb9',
				200: '#ffe798',
				300: '#ffdc68',
				400: '#ffd54b',
				500: '#ffcb1e',
				DEFAULT: '#ffcb1e',
				600: '#e8b91b',
				700: '#b59015',
				800: '#8c7011',
				900: '#6b550d',
				950: '#6b550d', // missing
			},
			success: {
				25: '#edfef4', // missing
				50: '#edfef4',
				100: '#c7fcdc',
				200: '#acfacb',
				300: '#86f8b3',
				400: '#6ef7a5',
				500: '#4af58e',
				DEFAULT: '#4af58e',
				600: '#43df81',
				700: '#35ae65',
				800: '#29874e',
				900: '#1f673c',
				950: '#1f673c', // missing
			},
			secondary: {
				25: '#e6e9f0', // missing
				50: '#e6e9f0',
				100: '#b0bbd1',
				200: '#8a9bbb',
				300: '#546d9c',
				400: '#335189',
				500: '#00256b',
				DEFAULT: '#00256b',
				600: '#002261',
				700: '#001a4c',
				800: '#00143b',
				900: '#00102d',
				950: '#00102d', // missing
			},
			neutral: {
				50: '#e6fdff',
				100: '#b0f8ff',
				200: '#8af5ff',
				300: '#54f1ff',
				400: '#33eeff',
				500: '#00eaff',
				DEFAULT: '#00eaff',
				600: '#00d5e8',
				700: '#00a6b5',
				800: '#00818c',
				900: '#00626b',
			},
		},
		logo: 'reach_more_logo.svg',
		grayLogo: 'reach_more_logo.svg',
		whatsAppSupportNumber: '971505655869',
		imagePlaceholder: 'assets/v2/reach-more/reach-more-placeholder.png',
		whatsAppMessageColor: '#b0ccf9',
		currency: 'usd',
	},
};

export const configs =
	process.env.MIX_APP_BRAND === 'Linker' ? brandsConfigs.linker : brandsConfigs.reachMore;
